import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { map } from 'rxjs/operators';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, TypeOfEnterpriseService, AppService } from '../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class TypeOfEnterprise {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-type-of-enterprise',
  templateUrl: './type-of-enterprise.component.html'
})
export class TypeOfEnterpriseComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    typeofenterpriseList: TypeOfEnterprise[] = []; // Table Data list
    isSubmitted = false;
    // countryAddForm: FormGroup;
    getTypeofenterprise = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;

    constructor(
                public router: Router,
                private dataService:TypeOfEnterpriseService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }

    typeofenterprise = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;

    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allTypeofenterprise();
    }
  
    allTypeofenterprise(){
      this.loadShow();
      this.dataService.getAllTypeofenterprise()
          .pipe().subscribe(data => { 
            this.typeofenterpriseList = data['typeofenterprise']; 
            this.dtTrigger.next(); // Data Table
            this.loadHide();
          });
        }
  
    open(content) {
  
      if (this.getTypeofenterprise.id !=null) {
        this.getTypeofenterprise.id='';
      }
      this.isSubmitted = false;
      this.typeofenterprise.name = '',
      this.typeofenterprise.description = '',
      this.typeofenterprise.is_active = 'Y';
      this.modalTitle = "Add Type of enterprise";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.getTypeofenterprise(id)
          .pipe().subscribe(data => { 
                  this.getTypeofenterprise = data['typeofenterprise']; 
                  this.typeofenterprise = {
                        id:this.getTypeofenterprise.id,
                        name:this.getTypeofenterprise.name,                        
                        description:this.getTypeofenterprise.description,
                        is_active:this.getTypeofenterprise.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit type of enterprise";
                  this.modalReference = this.modalService.open(content);
            });
        }

    save(val,f){
      this.isSubmitted = true;
      if(f.form.valid) {
        this.loadShow()
        if(val.id == ''){
          this.dataService.save(this.typeofenterprise)
              .pipe().subscribe(data =>{
                if(data['status']== 200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Type of enterprise saved successfully', true);
                  this.allTypeofenterprise();
                }
                else if(data['status'] == 422){
                  this.alertService.error(data.mesg.name)
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }else{
                  this.alertService.error("errors")
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }
               
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }else{
          this.dataService.typeofenterpriseUpdate(this.typeofenterprise)
              .pipe().subscribe(data =>{
                if(data['status'] == 200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Type of enterprise updated successfully', true);
                  this.allTypeofenterprise();
                }else if(data['status'] ==300){
                  this.loadHide()
                  this.alertService.error(data.mesg);
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                }
                
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
           }
        }
    }
  
    delete(id){
      if(confirm("Are you sure to delete")) {
        this.dataService.typeofenterpriseDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Sector of enterprise deleted successfully', true);
                this.allTypeofenterprise();
              }else{
                this.alertService.error('Sector of enterprise error');
              }
            },error =>{
              this.alertService.error(error);
            });
         }
      }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
    }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
